import React from 'react';
//import api from './../../../services/api';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css'
import Collapse from 'react-collapse';

class Forms_RICadastro extends React.Component {
    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            gender: "",
            birth: "",
            cpf: "",
            phone: "",
            password: "",
            institucion_name: "",
            institucion_adress: "",
            loading: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect_g = this.handleSelect_g.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
    
    handleSelect_g(event){
        this.setState({ gender: event.target.value});
    }

    handleSubmit = evt => {
        evt.preventDefault();
        this.setState({loading: true})
        const agent = {
            name: this.state.name,
            email: this.state.email,
            gender: this.state.gender,
            birth: this.state.birth,
            cpf: this.state.cpf,
            phone: this.state.phone,
            password: this.state.password,
            institucion_name: this.state.institucion_name,
            institucion_adress: this.state.institucion_adress,
            authenticated: false,
        };

        axios.post(`https://convida-api-official.herokuapp.com/agent`, agent)
            .then(res => {
                console.log(res);
                console.log(res.data);
                this.setState({loading: false})
                alert("Usuário cadastrado com sucesso!")
                this.props.history.push("/RI_Login");
            })
    }
    render() {
        return (
            <form onSubmit={this.handleSubmit}  id="forms-RI-Cadastro">
                <h1 id="tittle-forms-cme">Formulário de Cadastro</h1>
                <br></br>
                <p id="RI-Title-Cadastro" >Nome</p>
                <input onChange={this.handleChange} name="name" placeholder="Insira o nome do representante de instituição:" id="RI-Cadastro" required />
                <p id="RI-Title-Cadastro" >E-mail</p>
                <input onChange={this.handleChange} name="email" placeholder="Insira seu e-mail:" id="RI-Cadastro" required/>
                <p id="RI-Title-Cadastro-Paciente" >Genêro</p>
                <select value={this.state.gender} onChange={this.handleSelect_g} id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value='Masculino'>Masculino</option>
                    <option value='Feminino'>Feminino</option>
                    <option value='Outro'>Outro</option>
                </select>
                <p id="RI-Title-Cadastro" >Data de nascimento</p>
                <input onChange={this.handleChange} name="birth" type="date"  placeholder="Insira sua data de nascimento: (dd/mm/aaaa)" id="RI-Cadastro" required/>
                <p id="RI-Title-Cadastro" >CPF</p>
                <input onChange={this.handleChange} name="cpf" placeholder="Insira seu CPF:" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Número de telefone</p>
                <input onChange={this.handleChange} name="phone" placeholder="Insira seu número de telefone:" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Nome da instituição</p>
                <input onChange={this.handleChange} name="institucion_name" placeholder="Insira o nome da instituição:" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Endereço da instituição</p>
                <input onChange={this.handleChange} name="institucion_adress" placeholder="Insira o endereço da instituição:" id="RI-Cadastro" />
                <p id="RI-Title-Cadastro" >Senha</p>
                <input onChange={this.handleChange} name="password" placeholder="Insira uma senha:" id="RI-Cadastro" required/>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button onClick={() => this.handleSubmit} id="RI-Cadastro">
                        <Collapse isOpened={this.state.loading}>
                            <Spinner color="#FFFFFF" />
                        </Collapse>
                        <p>Enviar</p>
                    </button>
                </div>
            </form>
        );
    }
}
Forms_RICadastro = withRouter(Forms_RICadastro);
export default Forms_RICadastro;
